// store Vuex module

const state = () => ({
  stores: [],
  googleReviews: []
})

const getters = {
  stores (state) {
    return state.stores
  },
  googleReviews (state) {
    return state.googleReviews
  }
}

const mutations = {
  setStores (state, stores) {
    state.stores = stores
  },
  setGoogleReviews (state, reviews) {
    state.googleReviews = reviews
  }
}

const actions = {
  getStores (context) {
    return this.$api.getStores().then((resp) => {
      context.commit('setStores', resp.data.data)
      return resp.data
    }).catch(e => e.response.data)
  },
  getGoogleReviews (context) {
    const params = {}
    if (context.getters.currentStore && context.getters.currentStore.id) {
      params.store_id = context.getters.currentStore.id
    }
    return this.$api.getStoreReviews(params).then((resp) => {
      context.commit('setGoogleReviews', resp.data.data || [])
      return resp.data
    }).catch(() => {
      context.commit('setGoogleReviews', [])
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
